import { createContext } from 'react';
export const ButtonGroupContext = /*#__PURE__*/createContext({
  size: undefined
});
//# sourceMappingURL=ButtonGroupContext.js.map